import getPageName from './getPageName';

// const citizenRequest = 'https://localhost:44328/CitizenRequest/NewInternationalCommerceRequest'; // debug
const citizenRequest =
  'https://2024.api.tgu-dpo.ru/citizenrequest/NewInternationalCommerceRequest';
const crmRequest = 'https://sigmaedu.ru/handler.php';

// Добавление disabled кнопки отправки формы
export function setFormCheckbox(arr, btn) {
  arr.forEach((item) => {
    item.addEventListener('change', function () {
      if (!arr.find((checkbox) => !checkbox.checked)) {
        btn.removeAttribute('disabled');
      } else {
        btn.setAttribute('disabled', 'disabled');
      }
    });
  });
}

// Установка формы
export function setForm(selector, phoneIti) {
  var form = document.querySelector(selector);

  if (!form) {
    return;
  }

  form.addEventListener('submit', function (e) {
    sendForm(form, e, phoneIti);
  });

  addMaxLengthPromocode(form);

  onFormFilling(form, () => {
    ym(89966386, 'reachGoal', 'FormStart');
    VK.Goal('initiate_checkout');
    VK.Retargeting.Event('initiate_checkout');
    fbq('track', 'InitiateCheckout');

    //Mail.ru
    var _tmr = window._tmr || (window._tmr = []);
    _tmr.push({
      id: '3272381',
      type: 'reachGoal',
      goal: 'initiate_checkout',
    });
  });
}

/* Скачивание pdf файла при отправке основной формы */
function downloadPdf() {
  if (
    getPageName() === 'marketplaces' ||
    getPageName() === 'marketplace' ||
    getPageName() === 'marketplaces-pro'
  ) {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/marketplace_file.pdf');
    link.setAttribute('download', 'marketplace_file');
    link.click();
  } else if (getPageName() === 'dataanalyst') {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/dataanalyst.pdf');
    link.setAttribute('download', 'dataanalyst');
    link.click();
  } else if (
    getPageName() === 'psycholog' ||
    getPageName() === 'psycholog-cons'
  ) {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/psycholog.pdf');
    link.setAttribute('download', 'psycholog');
    link.click();
  } else if (getPageName() === 'onecprogrammer') {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/onecprogrammer.pdf');
    link.setAttribute('download', 'onecprogrammer');
    link.click();
  } else if (
    getPageName() === 'foreign-trade' ||
    getPageName() === 'trade-china'
  ) {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/foreigntrade.pdf');
    link.setAttribute('download', 'foreigntrade');
    link.click();
  } else if (getPageName() === 'graphicdesigner') {
    var link = document.createElement('a');
    link.setAttribute('href', '/files/graphicdesigner.pdf');
    link.setAttribute('download', 'graphicdesigner');
    link.click();
  }
}

/* Спиннер */
function createLoader() {
  const loader = document.createElement('div');
  loader.classList.add('loader');
  loader.innerHTML = `
        <div class="loader-wrap">
            <div class="ball-spin-fade-loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <p class="loader-text">Сейчас вы будете перенаправлены<br> на страницу оплаты</p>
        </div>
    `;

  document.body.append(loader);
}

function removeLoader() {
  const loader = document.querySelector('.loader');

  if (loader) {
    loader.remove();
  }
}

/* Добавление скрипта AdvCake на сайт */
function addAdvCakeScript(id, OdinId, program, email, RoistatCookie) {
  const pageUrl = document.location.href;
  let advcakeCookie = getCookie('advcake_track_id');

  window.advcake_data = window.advcake_data || [];
  window.advcake_data.push({
    pageType: 6,
    user: {
      email: `md5(${email})`,
      type: '',
    },
    leadInfo: {
      id: `${id}`,
      leadid: `${OdinId}`,
      name: `${program}`,
      totalPrice: 0,
      coupon: '',
      marketing_cat: 3,
      RoistatCookie: `${RoistatCookie}`,
      trackId: `${advcakeCookie}`,
      url: `${pageUrl}`,
    },
  });
}

/* Инициализация поля телефона */
const listCountries = [
  'az',
  'am',
  'by',
  'kz',
  'kg',
  'md',
  'ru',
  'tj',
  'tm',
  'uz',
];

export class Phone {
  constructor(options) {
    this.$el = document.querySelector(options.id);
    this.iti = options.iti;
  }

  setupMaskPhone() {
    if (this.$el) {
      this.iti = window.intlTelInput(this.$el, {
        separateDialCode: true,
        preferredCountries: ['ru'],
        initialCountry: 'auto',
        geoIpLookup: function (callback) {
          fetch('https://ipapi.co/json')
            .then(function (res) {
              return res.json();
            })
            .then(function (data) {
              if (!listCountries.includes(data.country_code)) {
                callback('ru');
              } else {
                callback(data.country_code);
              }
            })
            .catch(function () {
              callback('ru');
            });
        },
        utilsScript: '/js/utils.js',
      });

      const setIntervalStartPlaceholder = setInterval(() => {
        let placeholderInputPhone = this.$el.placeholder;

        if (placeholderInputPhone != '') {
          let maskNumber = placeholderInputPhone.replace(/[0-9+]/gi, '9');

          $(this.$el).mask(maskNumber, { autoclear: false });

          clearInterval(setIntervalStartPlaceholder);
        }
      }, 500);

      this.$el.addEventListener('countrychange', function () {
        let placeholderInputPhone = document.getElementById(
          this.id
        ).placeholder;
        let maskNumber = placeholderInputPhone.replace(/[0-9+]/gi, '9');

        $('#' + this.id).mask(maskNumber, { autoclear: false });
      });
    }
  }
}

const phone = new Phone({
  iti: 'itiPhone',
  id: '#phone',
});
phone.setupMaskPhone();

const phoneSpecial = new Phone({
  iti: 'itiPhoneHome',
  id: '#phone-special',
});
phoneSpecial.setupMaskPhone();

const phonePDF = new Phone({
  iti: 'itiPhonePDF',
  id: '#phone-pdf',
});
phonePDF.setupMaskPhone();

let phoneSale = new Phone({
  iti: 'itiPhoneSale',
  id: '#phone-sale',
});
phoneSale.setupMaskPhone();

// Получение cookie
function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

var validators = {
  requried: function (value, error) {
    if (!value || value.length === 0) {
      error.message = 'Это поле обязательно';
      return false;
    } else {
      return true;
    }
  },
  email: function (value, error) {
    if (/.+@.+\..+/.test(value)) {
      return true;
    } else {
      error.message = 'Некорректный email';
      return false;
    }
  },
  phone: function (status, error) {
    if (status) {
      return true;
    } else {
      error.message = 'Некорректный номер';
      return false;
    }
  },
};

// Показ ошибок при заполнении формы
function showError(error, field) {
  if (error.message) {
    var errorContainer = document.createElement('div');
    errorContainer.textContent = error.message;
    errorContainer.classList.add('form__error-container');
    field.appendChild(errorContainer);
  }
}

// Валидация формы
function validate(form, phoneIti) {
  var result = true;
  Array.from(form.querySelectorAll('.form__field')).forEach(function (
    formField
  ) {
    var error = {};
    var control = formField.querySelector('select, input, textarea');
    if (formField.querySelector('.form__required')) {
      if (!validators.requried(control.value, error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
        return;
      }
    }

    if (control.id === 'phone') {
      if (!validators.phone(phone.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (control.id === 'phone-sale') {
      if (!validators.phone(phoneSale.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (control.id === 'phone-pdf') {
      if (!validators.phone(phonePDF.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (control.id === 'phone-special') {
      if (!validators.phone(phoneSpecial.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (control.id === 'phone-modal') {
      if (!validators.phone(phoneIti.iti.isValidNumber(), error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    if (
      control.id === 'email' ||
      control.id === 'email-sale' ||
      control.id === 'email-pdf' ||
      control.id === 'email-special'
    ) {
      if (!validators.email(control.value, error)) {
        showError(error, formField);
        control.classList.add('form__field--invalid');
        result = false;
      }
    }

    let invalidField = form.querySelector('.form__field--invalid');
    if (invalidField) {
      invalidField.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  });
  return result;
}

// Удаление ошибок с формы
function deleteErrors(form) {
  form.querySelectorAll('.form__error-container').forEach(function (el) {
    el.remove();
  });
  form.querySelectorAll('.form__field--invalid').forEach(function (el) {
    el.classList.remove('form__field--invalid');
  });
}

function formSubmitCommerce(data) {
  $.ajax({
    url: crmRequest,
    method: 'POST',
    contentType: 'application/json;charset=utf-8',
    data: JSON.stringify(data),
    success: function () {},
    error: function () {},
  });
}

function formSubmitPayment(data) {
  fetch(crmRequest, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then(createLoader())
    .then((result) => {
      removeLoader();

      if (result == 'error_payment_link') {
        openPaymentCourseOnMail();
      } else {
        const a = document.createElement('a');
        a.href = result;
        a.style.display = 'none';
        document.body.append(a);
        a.click();
      }
    });
}

/* Модальное окно успешно отправленной формы */
function successModal() {
  let modal = document.querySelector('#quiz-success');
  if (!modal) {
    modal = document.createElement('div');
    ['modal', 'quiz'].forEach((additionalClass) => {
      modal.classList.add(additionalClass);
    });
    modal.id = 'quiz-success';
    modal.innerHTML = '<div class="quiz__content"></div>';

    document.body.append(modal);
  }

  const a = document.createElement('a');
  a.href = '#quiz-success';
  a.rel = 'modal:open';
  a.style.display = 'none';
  document.body.append(a);

  window.openSuccessModal = () => {
    modal.classList.add('rvr-modal');
    modal.classList.add('succes-quiz');
    setStyles(modal, {
      position: 'relative',
      paddingBottom: '2rem',
    });
    modal.querySelector('.quiz__content').innerHTML = /*html*/ `
      <div class="success">
          <div class="success__container">
              <div class="success__wrap">
                  <h2 class="success__h2">Благодарим
                      за&nbsp;вашу заявку!</h2>
                  <img src="/img/main/check.png" alt="Иконка">
                  <p class="success__p">Наш менеджер свяжется с&nbsp;вами в&nbsp;ближайшее время, чтобы обсудить
                      все детали.</p>
                  <a href="/" class="success__link btn">Вернуться на главную</a>
              </div>
          </div>
      </div>
    `;
    a.click();
  };

  window.openSuccessModalCatalog = () => {
    modal.classList.add('rvr-modal');
    setStyles(modal, {
      position: 'relative',
      paddingBottom: '2rem',
    });
    modal.querySelector('.quiz__content').innerHTML = /*html*/ `
        <div>
          <h3 style="margin-bottom: 1rem">
              Благодарим за заявку!
          </h3>
          <p>Наш менеджер свяжется с вами в ближайшее время.</p>
        </div>
    `;
    a.click();
  };

  window.openSuccessModalPdf = () => {
    modal.classList.add('rvr-modal');
    setStyles(modal, {
      position: 'relative',
      paddingBottom: '2rem',
    });

    modal.querySelector('.quiz__content').innerHTML = /*html*/ `
                <h3 style="margin-bottom: 1rem">
                    Благодарим за заявку!
                </h3>
                <p>В ближайшее время Вам на почту придёт письмо с полной программой обучения</p>
              </div>
          `;
    a.click();

    const getPdf = document.createElement('a');
    document.body.appendChild(getPdf);

    switch (getPageName()) {
      case 'softwaretesting':
        getPdf.setAttribute(
          'download',
          'УТП Тестировщик программного обеспечения 144ч'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/Softwaretesting.pdf');
        break;
      case 'marketplace':
        getPdf.setAttribute(
          'download',
          '15 полезных материалов для будущего менеджера маркетплейсов'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/Marketplace.pdf');
        break;
      case 'smmtargetologist':
        getPdf.setAttribute('download', 'УТП Таргетолог и SMM-специалист 144ч');
        getPdf.setAttribute('href', '/files/trainingPDF/SmmTargetologist.pdf');
        break;
      case 'dataanalyst':
        getPdf.setAttribute('download', 'УТП_Аналитик данных_256 ч');
        getPdf.setAttribute('href', '/files/trainingPDF/Dataanalyst.pdf');
        break;
      case 'graphicdesign':
        getPdf.setAttribute(
          'download',
          'УТП Графический дизайн_ с нуля до первых проектов 256ч'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/GraphicDesign.pdf');
        break;
      case 'graphicdesigner':
        getPdf.setAttribute(
          'download',
          'УТП Графический дизайн_ с нуля до первых проектов 256ч'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/GraphicDesign.pdf');
        break;
      case 'webprogrammer':
        getPdf.setAttribute(
          'download',
          'УТП Web-программист - с нуля до первых проектов 144ч'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/Webprogrammer.pdf');
        break;
      case 'psychologist':
        getPdf.setAttribute('download', 'УТП Психолог-консультант 256 ч');
        getPdf.setAttribute('href', '/files/trainingPDF/Psychologist.pdf');
        break;
      case 'psycholog':
        getPdf.setAttribute('download', 'УТП Психолог-консультант 256 ч');
        getPdf.setAttribute('href', '/files/trainingPDF/Psychologist.pdf');
        break;
      case 'accountant':
        getPdf.setAttribute(
          'download',
          'УТП_Бухгалтер_субъекта_малого_бизнеса_256 ч'
        );
        getPdf.setAttribute('href', '/files/trainingPDF/Accountant.pdf');
        break;
    }
    getPdf.click();
    document.body.removeChild(getPdf);
  };

  window.openPaymentCourseOnMail = () => {
    modal.classList.add('rvr-modal');
    setStyles(modal, {
      position: 'relative',
      paddingBottom: '2rem',
    });
    modal.querySelector('.quiz__content').innerHTML = `
              <h3 style="margin-bottom: 1rem">
                Спасибо за ожидание!
              </h3>
              <p style="margin-bottom: 1rem">На вашу электронную почту отправлено письмо со ссылкой на оплату курса.</p>
              <p style="margin-bottom: 0"><strong>Отличного дня!</strong></p>
              </div>
          `;
    a.click();
  };
}

/* Добавление стилей */
function setStyles(el, stylesObject) {
  if (!el) {
    return;
  }
  Object.keys(stylesObject).forEach((key) => {
    el.style[key] = stylesObject[key];
  });
}

/* Отслеживание заполнения формы */
function onFormFilling(form, callback) {
  const controls = form.querySelectorAll('input, select, textarea');
  let changed = false;
  controls.forEach((control) => {
    $(control).one('blur', (e) => {
      if (!changed) {
        callback(e);
        changed = true;
      }
    });
  });
}

// Максимальное число символов для поля "Промокод"
function addMaxLengthPromocode(form) {
  const promocode = form.querySelector('#promocode');
  if (promocode) {
    promocode.setAttribute('maxlength', '30');
  }
}

// Отправка формы
let firstFormData = {};

function sendForm(form, e, phoneIti) {
  var sendBtn = form.querySelector(
    'button[type="submit"], input[type="submit"]'
  );
  e.preventDefault();
  deleteErrors(form);
  var data = {};

  if (!validate(form, phoneIti)) {
    return;
  }

  sendBtn.disabled = true;
  Array.from(new FormData(form)).forEach(function (formElement) {
    var key = formElement[0];
    var value = formElement[1];

    if (key == 'Phone') {
      if (form.id === 'form-sale') {
        data[key] = phoneSale.iti.getNumber();
      } else if (form.id === 'form-pdf') {
        data[key] = phonePDF.iti.getNumber();
      } else if (form.id === 'form-special') {
        data[key] = phoneSpecial.iti.getNumber();
      } else if (form.id === 'form-modal') {
        data[key] = phoneIti.iti.getNumber();
      } else {
        data[key] = phone.iti.getNumber();
      }
    } else {
      data[key] = value;
    }
  });

  var url = document.location.href;

  var paramsStartIndex = url.indexOf('?');
  if (paramsStartIndex > -1) {
    url
      .slice(paramsStartIndex + 1, url.length)
      .split('&')
      .map(function (utmString) {
        return utmString.split('=');
      })
      .forEach(function (utmMark) {
        var key = utmMark[0];
        key = key[0].toUpperCase() + key.slice(1, key.length);
        var value = utmMark[1];
        value =
          value.indexOf('#') > -1 ? value.slice(0, value.indexOf('#')) : value;
        data[key] = value;
      });
  }

  // Roistat
  let roistatCookie = getCookie('roistat_visit');

  if (!!roistatCookie) {
    data['RoistatCookie'] = roistatCookie;
  }

  // Url landing
  data['Landing'] = url.split('?')[0] || url;

  /* Если выбрана оплата Рассрочкой, то передаем значение длительности рассрочки в поле Block */
  if (data['Block'] == 'installment') {
    if (data['InstallmentDuration'] != undefined) {
      data['Block'] = data['InstallmentDuration'];
    }
  }

  if (form.id == 'form-app') {
    firstFormData = { ...data };
  }


  $.ajax({
    url: citizenRequest,
    method: 'POST',
    contentType: 'application/json;charset=utf-8',
    data: JSON.stringify(data),

    success: function (result) {
      addAdvCakeScript(
        result.requestId,
        result.odinId,
        result.programName,
        data.Email,
        data.RoistatCookie
      );

      sendBtn.disabled = false;
      VK.Goal('lead');
      VK.Retargeting.Event('lead');
      fbq('track', 'Lead');

      //Mail.ru
      var _tmr = window._tmr || (window._tmr = []);
      _tmr.push({ id: '3272381', type: 'reachGoal', goal: 'lead' });

      form.reset();

      if (form.id === 'form-pdf') {
        /* Временный перенос функции отправки в АМО */
        formSubmitCommerce(data);
        ym(89966386, 'reachGoal', 'FormSubmitAndGetPDF');
        /* */
        openSuccessModalPdf();
      } else if (
        form.id === 'form-catalog' ||
        form.id === 'form-modal' ||
        form.id === 'form-special'
      ) {
        formSubmitCommerce(data);
        openSuccessModalCatalog();
        ym(89966386, 'reachGoal', 'FormSubmit');
      } else if (form.id === 'form-sale') {
        ym(89966386, 'reachGoal', 'FormSubmit');
        if (
          form.classList.contains('payment__form') &&
          data['Block'] != 'consultation'
        ) {
          /* Отправка данных в АМО для оплаты */
          formSubmitPayment(data);
        } else {
          /* Временный перенос функции отправки в АМО */
          formSubmitCommerce(data);
          /* */
          openSuccessModal();
        }
      } else if (form.id === 'form-app') {
        ym(89966386, 'reachGoal', 'FormSubmit');
        if (
          form.classList.contains('payment__form') &&
          data['Block'] != 'consultation'
        ) {
          /* Отправка данных в АМО для оплаты */
          formSubmitPayment(data);
        } else if (
          form.classList.contains('payment__form') &&
          data['Block'] == 'consultation'
        ) {
          /* Временный перенос функции отправки в АМО */
          formSubmitCommerce(data);
          openSuccessModal();

        } else {
          /* Временный перенос функции отправки в АМО */
          formSubmitCommerce(data);
          /* */
          openSuccessModal();
        }
      } else if (form.id === 'form-questionnaire') {
        /* Временный перенос функции отправки в АМО */
        formSubmitCommerce(data);
        /* */
        openSuccessModal();

        document.getElementById('form-first').style.display = 'flex';
        document.getElementById('form-second').style.display = 'none';
      } else {
        ym(89966386, 'reachGoal', 'FormSubmit');
        /* Временный перенос функции отправки в АМО */
        formSubmitCommerce(data);
        /* */
        openSuccessModal();
      }

      if (form.id === 'form-app') {
        downloadPdf();

        if (
          window.location.pathname === '/program/marketplaces' ||
          window.location.pathname === '/program/marketplace'
        ) {
          ym(89966386, 'reachGoal', 'FormSubmitAndGetPDF');
        }
      }
    },
    error: function () {
      sendBtn.disabled = false;
    },
  });
}

const form = () => {
  /* Список доступных тарифов для программ */
  const tariffsPrograms = {
    webprogrammer: {
      Middle: '144 часа',
    },
    psychologist: {
      Pro: '256 часов',
    },
    psycholog: {
      Pro: '256 часов',
    },
    marketplace: {
      Middle: '144 часа',
    },
    marketplaces: {
      Middle: '144 часа',
    },
    softwaretesting: {
      Middle: '144 часа',
    },
    graphicdesign: {
      Pro: '256 часов',
    },
    graphicdesigner: {
      Pro: '256 часов',
    },
    'data-analysis': {
      Pro: '256 часов',
    },
    accountant: {
      Pro: '256 часов',
    },
    uidesign: {
      Middle: '144 часа',
    },
    smmtargetologist: {
      Middle: '144 часа',
    },
    onecprogr: {
      Pro: '256 часов',
    },
    onecprogrammer: {
      Pro: '256 часов',
    },
    foreigntrade: {
      Middle: '144 часа',
    },
    rykovodproject: {
      Junior: '72 часа',
    },
    'foreign-trade': {
      Middle: '144 часа',
    },
    'trade-china': {
      Middle: '144 часа',
    },
    'psycholog-cons': {
      Pro: '256 часов',
    },
    'marketplaces-pro': {
      Middle: '144 часа',
    },
  };

  /* Поиск доступных тарифов */
  function searchTariffs() {
    const Programs = document.getElementById('ProgramForm'),
      Tariffs = document.getElementById('TariffForm'),
      url = document.location.href;

    if (Programs) {
      Programs.onchange = (e) => {
        if (Programs.selectedIndex != '-1') {
          let program =
            Programs.options[Programs.selectedIndex].getAttribute('program');

          try {
            Tariffs?.removeAttribute('disabled');
            Tariffs && createOptionsTariffs(tariffsPrograms[program]);
          } catch (e) {
            console.log(e);
          }
        }
      };
    } else if (url.includes('program')) {
      const pageName = getPageName();

      for (let key in tariffsPrograms) {
        if (key == pageName) {
          Tariffs && createOptionsTariffs(tariffsPrograms[pageName]);
        }
      }
    }

    /* Создание option для поля Тарифы */
    function createOptionsTariffs(obj) {
      [...Tariffs.children].map((item, idx) => {
        if (idx > 0) {
          item.remove();
        }
      });

      for (let key in obj) {
        let option = new Option(obj[key], key, false, false);

        Tariffs.append(option);
      }
    }
  }

  /* Подстановка цен в левую часть формы программ, в зависимости от длительности программы */
  function setPrices(data) {
    let formPrice = document.querySelector('.form__price').children,
      formDuration = document.querySelector('.form-left-duration');

    if (Object.values(data).join() == '144 часа') {
      formDuration.textContent = '2';
      if (getPageName() == 'marketplace' || getPageName() == 'marketplaces') {
        formPrice[0].getElementsByTagName('dd')[0].innerHTML =
          '95&nbsp;900&nbsp;руб.';
        formPrice[1].getElementsByTagName('dd')[0].innerHTML =
          '67&nbsp;130&nbsp;руб.';
        formPrice[2].getElementsByTagName('dd')[0].innerHTML =
          '2&nbsp;797&nbsp;руб.';
        return;
      } else if (
        getPageName() == 'foreigntrade' ||
        getPageName() == 'foreign-trade' ||
        getPageName() == 'uidesign'
      ) {
        formPrice[0].getElementsByTagName('dd')[0].innerHTML =
          '89&nbsp;972&nbsp;руб.';
        formPrice[1].getElementsByTagName('dd')[0].innerHTML =
          '44&nbsp;986&nbsp;руб.';
        formPrice[2].getElementsByTagName('dd')[0].innerHTML =
          '1&nbsp;874&nbsp;руб.';
      } else {
        formPrice[0].getElementsByTagName('dd')[0].innerHTML =
          '74&nbsp;975&nbsp;руб.';
        formPrice[1].getElementsByTagName('dd')[0].innerHTML =
          '37&nbsp;488&nbsp;руб.';
        formPrice[2].getElementsByTagName('dd')[0].innerHTML =
          '1&nbsp;562&nbsp;руб.';
      }
    } else {
      if (
        getPageName() == 'graphicdesign' ||
        getPageName() == 'graphicdesigner'
      ) {
        formPrice[0].getElementsByTagName('dd')[0].innerHTML =
          '149&nbsp;972&nbsp;руб.';
        formPrice[1].getElementsByTagName('dd')[0].innerHTML =
          '74&nbsp;986&nbsp;руб.';
        formPrice[2].getElementsByTagName('dd')[0].innerHTML =
          '3&nbsp;124&nbsp;руб.';
      }
    }
  }

  // Установка масок
  function setMasks() {
    $('#phone').mask('+7 (999) 999-99-99', { autoclear: false });
    $('#phone-sale').mask('+7 (999) 999-99-99', { autoclear: false });
    $('#phone-pdf').mask('+7 (999) 999-99-99', { autoclear: false });
    $('#phone-modal').mask('+7 (999) 999-99-99', { autoclear: false });
  }

  if (getPageName() !== 'thank-you') {
    $(function () {
      setMasks();
      setForm('#form-app');
      addFormModalPartners();
      searchTariffs();

      if (
        document.querySelector('#personal-policy') &&
        document.querySelector('#personal-agreement')
      ) {
        setFormCheckbox(
          [
            document.querySelector('#personal-policy'),
            document.querySelector('#personal-agreement'),
          ],
          document.querySelector('#submit-form')
        );
      }

      if (
        document.querySelector('#personal-policy-questionnaire') &&
        document.querySelector('#personal-agreement-questionnaire')
      ) {
        setFormCheckbox(
          [
            document.querySelector('#personal-policy-questionnaire'),
            document.querySelector('#personal-agreement-questionnaire'),
          ],
          document.querySelector('#submit-form-questionnaire')
        );
      }

      if (
        document.querySelector('#personal-data-sale') &&
        document.querySelector('#personal-oferta-sale')
      ) {
        setFormCheckbox(
          [
            document.querySelector('#personal-data-sale'),
            document.querySelector('#personal-oferta-sale'),
          ],
          document.querySelector('#submit-sale')
        );
      }

      if (document.querySelector('#personal-data-pdf')) {
        setFormCheckbox(
          [document.querySelector('#personal-data-pdf')],
          document.querySelector('#submit-pdf')
        );
      }

      if (document.querySelector('#personal-data-mailing')) {
        setFormCheckbox(
          [document.querySelector('#personal-data-mailing')],
          document.querySelector('#submitFormMailing')
        );
      }
    });
  }

  /* Инициализация селектов */
  function setSelects() {
    const selectors = [
      {
        id: '#ProgramForm',
        placeholder: 'Программа обучения',
      },
      {
        id: '#DirectionForm',
        placeholder: 'Направление',
      },
      {
        id: '#TariffForm',
        placeholder: 'Длительность программы',
      },
      {
        id: '#PayForm',
        placeholder: 'Выберите услугу',
      },
      {
        id: '#GoalStudy',
        placeholder: 'Цель обучения',
      },
      {
        id: '#MonthlyIncome',
        placeholder: 'Доход',
      },
      {
        id: '#LevelOfEducation',
        placeholder: 'Образование',
      },
      {
        id: '#Age',
        placeholder: 'Возраст',
      },
      {
        id: '#AvailabilityDevices',
        placeholder: 'Техника для учебы',
      },
      {
        id: '#TimeToStudy',
        placeholder: 'Время для учебы',
      },
    ];

    selectors.forEach((item) => {
      let selector = $(item.id),
        message = '';

      selector.select2({
        placeholder: item.placeholder,
        language: {
          noResults: function () {
            return message;
          },
        },
        escapeMarkup: function (markup) {
          return markup;
        },
      });

      selector.val(null).trigger('change');
    });
  }

  /* Select2 */
  $(document).ready(function () {
    /* ВК метрика: более 30 сек на сайте */
    setTimeout(() => {
      VK.Retargeting.Event('PageView30sec');
    }, 30000);

    /* ВК метрика: более 60 сек на сайте */
    setTimeout(() => {
      VK.Retargeting.Event('PageView60sec');
    }, 60000);

    successModal();
    setSelects();
  });

  /* Для сайта Партнеров добавление формы в модальные окна */
  function addFormModalPartners() {
    const openModal = document.querySelectorAll('.teach_card'),
      modalPartners = document.querySelectorAll('.teach-modal .partners-modal');

    openModal.forEach((item, i) => {
      item.addEventListener('click', () => {
        for (let j = 0; j < modalPartners.length; j++) {
          modalPartners[j].innerHTML = '';
        }

        modalPartners[i].innerHTML = `
          <form id="form-sale">
            <div class="form-group">
                <div class="form__field">
                    <input type="tel" id="phone-sale" name="Phone" class="form__input">
                        <span class="form__required"></span>
                </div>
                <div class="form__field">
                    <input class="form__input" type="text" name="FirstName" id="name" placeholder="Имя"
                        maxlength="250">
                    <span class="form__required"></span>
                </div>
                <input type="hidden" value="-" name="LastName">
                <div class="form__field">
                    <input class="form__input" type="email" name="Email" id="email" placeholder="Email">
                    <span class="form__required"></span>
                </div>
                <div class="form__field">
                    <input class="form__input" type="text" name="Company" id="company"
                        placeholder="Компания">
                        <span class="form__required"></span>
                </div>
                <div class="form__field">
                    <input class="form__input" type="text" name="Comment" id="comment"
                        placeholder="Комментарий">
                </div>
                <div class="form__fields">
                  <div class="form__checkbox">
                    <input class="custom-checkbox" checked type="checkbox" class="agreement" id="personal-policy-sale">
                    <label class="form__label-check" for="personal-policy">
                      Нажимая кнопку &laquo;Отправить&raquo;, я&nbsp;соглашаюсь с&nbsp;условиями <a href="/files/oferta_file.pdf" class="form__oferta" target="blank" rel="noopener noreferrer"><span>публичной оферты</span></a> и <a href="/files/privacy_policy.pdf" class="form__politics" target="blank" rel="noopener noreferrer"><span>политики обработки персональных данных </span></a>
                    </label>
                  </div>
                  <div class="form__checkbox">
                    <input class="custom-checkbox" checked type="checkbox" class="agreement" id="personal-agreement-sale">
                    <label class="form__label-check" for="personal-agreement">
                      Я даю <a href="/files/agreement.pdf" target="blank" rel="noopener noreferrer"><span>согласие на обработку персональных данных</span></a>
                    </label>
                  </div>
                  <button type="submit" class="btn form__btn" id="submit-sale">Отправить</button>
                </div>
            </div>
        </form>
        `;

        phoneSale = new Phone({
          iti: 'itiPhoneSale',
          id: '#phone-sale',
        });
        phoneSale.setupMaskPhone();

        setFormCheckbox(
          [
            document.querySelector('#personal-policy-sale'),
            document.querySelector('#personal-agreement-sale'),
          ],
          document.querySelector('#submit-sale')
        );

        setForm('#form-sale');
      });
    });
  }

  // Функционал добавления поля длительности рассрочки
  (() => {
    const tariffMethods = document.querySelector('.tariffs__modal-methods');
    if (!tariffMethods) return;

    const durationSelectWrapper = document.querySelector(
      '[data-installment-duration]'
    );
    const validatorSpan =
      durationSelectWrapper.querySelector('.form__validator');
    let durationSelect = $('#InstallmentDuration');

    tariffMethods.addEventListener('click', (evt) => {
      if (evt.target.closest('[data-installment]')) {
        durationSelectWrapper.style.display = null;
        durationSelect.select2({
          placeholder: 'Длительность рассрочки',
        });
        durationSelect.val(null).trigger('change');
        validatorSpan.classList.add('form__required');
      } else {
        durationSelectWrapper.style.display = 'none';
        durationSelect.val(null);
        validatorSpan.classList.remove('form__required');
      }
    });
  })();

  /* Добавление поля длительности рассрочки на основных сайтах */
  (() => {
    const selectPayForm = document.getElementById('PayForm');

    if (!selectPayForm) return;

    const durationSelectWrapper = document.querySelector(
      '[data-installment-duration]'
    );
    const validatorSpan =
      durationSelectWrapper.querySelector('.form__validator');
    let durationSelect = $('#InstallmentDuration');

    selectPayForm.onchange = function (e) {
      let value = e.target.value;

      if (value == 'installment') {
        durationSelectWrapper.style.display = null;
        durationSelect.select2({
          placeholder: 'Длительность рассрочки',
        });
        durationSelect.val(null).trigger('change');
        validatorSpan.classList.add('form__required');
      } else {
        durationSelectWrapper.style.display = 'none';
        durationSelect.val(null);
        validatorSpan.classList.remove('form__required');
      }
    };
  })();

  /* Метрика на отправку формы в блоке formMailing */
  (() => {
    const submit = document.getElementById('submitFormMailing'),
      input = document.getElementById('inputFormMailing');

    if (!submit) return;

    submit?.addEventListener('click', () => {
      if (input.value != '') {
        ym(89966386, 'reachGoal', 'Subscription');
      }
    });
  })();
};

export default form;
